import { UntypedFormControl } from '@angular/forms';

export function errorTextBuilder(control: UntypedFormControl): string {
  let controlName: string;

  controlName = Object.keys(control.parent.controls).find((item) => control.parent.controls[item] === control);

  if (control.errors?.minlength) {
    return `At least ${control.errors?.minlength.requiredLength} characters required`;
  }

  if (control.errors?.maxlength) {
    return `Enter no more than ${control.errors?.maxlength.requiredLength} characters. 
            Introduced ${control.errors?.maxlength.actualLength}`;
  }

  if (control.errors?.pattern) {
    if (controlName === 'workspace') {
      return control.value[0] === '-' ? '"-" cannot be the first character' : 'Invalid characters entered';
    }
    return 'Invalid characters entered';
  }

  if (control.errors?.email) {
    return 'Invalid email';
  }

  if (control.errors?.msg) {
    return control.errors.msg;
  }

  switch (controlName) {
    case 'email':
      if (!control.value) return 'Enter email';
      break;
    case 'password':
      if (!control.value) return 'Enter password';
      else if (control.value && control.errors?.badPassword) return 'Upper and lower case letters and numbers required';
      break;
    case 'confirm_password':
    case 'password_confirmation':
      return control.value ? 'Passwords mismatch' : 'Confirm password';
    case 'login':
      if (!control.value) return 'Enter email';
      break;
    case 'phone':
      if (!control.value) return 'Enter phone';
      else if (control.value && control.invalid) return 'Phone is too short';
      break;
    case 'telegram':
      if (!control.value) return 'Enter telegram';
      break;
    case 'skype':
      if (!control.value) return 'Enter skype';
      break;
  }
  return 'Fill the field';
}
